import Message from "../../message";
import {useMainStore} from "@/store";

export default class InviteSent extends Message
{
    handle()
    {
        // TODO: THIS DOESN'T APPEAR TO ADD
        useMainStore().ADD_GUILD_INVITE(this.message.invite);
    }
}
